<div>
  <div
    bsModal
    #childModal="bs-modal"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-child-name"
    style="top: 30%">
    <div class="modal-dialog modal-md">
      <div
        class="modal-content"
        style="
          width: 596px;
          height: 100%;
          background: white;
          overflow: hidden;
          border-radius: 8px;
          outline: 1px #dce6f7 solid;
          outline-offset: -1px;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 24px;
          display: inline-flex;
        ">
        <div
          style="
            align-self: stretch;
            padding-top: 24px;
            padding-left: 24px;
            padding-right: 24px;
            overflow: hidden;
            justify-content: center;
            align-items: center;
            gap: 8px;
            display: inline-flex;
          ">
          <div
            style="
              flex: 1 1 0;
              color: #111010;
              font-size: 16px;
              font-family: Inter;
              font-weight: 600;
              word-wrap: break-word;
            ">
            {{ header || 'Confirmation' }}
          </div>
          <div style="width: 24px; height: 24px; position: relative; cursor: pointer" (click)="cancel()">
            <div class="cross" (click)="cancel()">
              <img src="assets/img/x.svg" alt="" />
            </div>
          </div>
        </div>

        <div
          style="
            align-self: stretch;
            padding-left: 24px;
            padding-right: 24px;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
            display: inline-flex;
          "
          *ngIf="message || messageHtml">
          <div
            style="
              flex: 1 1 0;
              color: #111010;
              font-size: 16px;
              font-family: Lato;
              font-weight: 400;
              word-wrap: break-word;
            ">
            <span *ngIf="message">{{ message }}</span>
            <span *ngIf="messageHtml" [innerHTML]="messageHtml"></span>
          </div>
        </div>

        <div
          style="
            align-self: stretch;
            padding-left: 24px;
            padding-right: 24px;
            padding-top: 16px;
            padding-bottom: 16px;
            background: white;
            overflow: hidden;
            justify-content: flex-end;
            align-items: center;
            gap: 16px;
            display: inline-flex;
          ">
          <button
            type="button"
            style="
              padding-left: 20px;
              padding-right: 20px;

              overflow: hidden;
              border-radius: 12px;
              outline: 1px #193f85 solid;
              outline-offset: -1px;
              justify-content: center;
              align-items: center;
              gap: 12px;
              display: flex;
              background: white;
              border: none;
              cursor: pointer;
              height: 39px;
            "
            (click)="cancel()">
            <div
              style="
                text-align: center;
                color: #2f353a;
                font-size: 16px;
                font-family: Inter;
                font-weight: 600;
                word-wrap: break-word;
              ">
              Cancel
            </div>
          </button>
          <button
            type="button"
            style="
              padding-left: 20px;
              padding-right: 20px;
              background: #265dc3;
              overflow: hidden;
              border-radius: 12px;
              justify-content: center;
              align-items: center;
              gap: 12px;
              display: flex;
              border: none;
              cursor: pointer;
              height: 39px;
            "
            (click)="confirm()">
            <div
              style="
                text-align: center;
                color: white;
                font-size: 16px;
                font-family: Lato;
                font-weight: 700;
                word-wrap: break-word;
              ">
              {{ confirmBtnText }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
